// src/pages/NomenclatureDirectory.js

import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UnifiedDirectory from "../components/UnifiedDirectory";
import {
  getNomenclature,
  createNomenclature,
  updateNomenclatureName,
  deleteNomenclature,
} from "../api/enterprise";
import { notifyError } from "../utils/toasts";

function NomenclatureDirectory() {
  const { t } = useTranslation();
  const { enterpriseId } = useParams();
  const [nomenclature, setNomenclature] = useState([]);

  const fetchNomenclature = useCallback(async () => {
    if (enterpriseId) {
      try {
        const result = await getNomenclature(enterpriseId);
        setNomenclature(result);
      } catch (error) {
        notifyError(error?.response?.data?.message || error.message);
      }
    }
  }, [enterpriseId]);

  useEffect(() => {
    fetchNomenclature();
  }, [fetchNomenclature]);

  const handleAddNomenclature = async (name) => {
    try {
      await createNomenclature(enterpriseId, name);
      await fetchNomenclature();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleEditNomenclature = async (item, newName) => {
    try {
      await updateNomenclatureName(item.nomenclature_id, newName);
      await fetchNomenclature();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleDeleteNomenclature = async (item) => {
    try {
      await deleteNomenclature(item.nomenclature_id);
      await fetchNomenclature();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  return (
    <UnifiedDirectory
      title={t("nomenclature")}
      data={nomenclature}
      onAdd={handleAddNomenclature}
      onEdit={handleEditNomenclature}
      onDelete={handleDeleteNomenclature}
      fields={["name"]}
      displayFields={["name", "upserted_at"]}
    />
  );
}

export default NomenclatureDirectory;
